import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import "../assets/css/DarkMode.css";

const DarkMode = () => {
  const [checked, setChecked] = useState(false);

  const setDark = () => {
    localStorage.setItem("theme", "dark");
    document.documentElement.setAttribute("data-theme", "dark");
  };

  const setLight = () => {
    localStorage.setItem("theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
  };

  const storedTheme = localStorage.getItem("theme");

  const prefersDark =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;

  const defaultDark =
    storedTheme === "dark" || (storedTheme === null && prefersDark);

  if (defaultDark) {
    setDark();
  }

  const toggleTheme = (e) => {
    if (e.target.checked) {
      setDark();
      setChecked(true);
    } else {
      setLight();
    }
  };

  return (
    <div className="toggle-theme-wrapper d-flex flex-row justify-content-center align-items-center">
      <span>
        <FontAwesomeIcon className="dark-text" icon={faSun} />
      </span>
      <label className="toggle-theme position-relative" htmlFor="checkbox">
        {checked ? (
          <input
            className="d-none checked"
            type="checkbox"
            id="checkbox"
            onChange={toggleTheme}
            defaultChecked={defaultDark}
          />
        ) : (
          <input
            className="d-none"
            type="checkbox"
            id="checkbox"
            onChange={toggleTheme}
            defaultChecked={defaultDark}
          />
        )}
        <div className="slider round position-absolute start-0 end-0 top-0 bottom-0"></div>
      </label>
      <span>
        <FontAwesomeIcon className="dark-text" icon={faMoon} />
      </span>
    </div>
  );
  
};

export default DarkMode;
